import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="bg-white border-b border-gray-200 py-4 px-8">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="logo flex items-center gap-3 no-underline">
          <img
            src="/images/main-logo-2.png"
            alt="HouseKeeper Logo"
            className="w-10 h-10"
          />
          <span className="text-md sm:text-2xl font-bold text-[#586989]">
            HouseKeeper
          </span>
        </Link>
        <nav className="flex gap-8 items-center">
          <Link
            to="https://housekeeper.host"
            target="_blank"
            className="text-[#586989] no-underline text-sm sm:text-base font-medium transition-colors hover:text-[#106A3A]"
          >
            HouseKeeper Website
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
